module.exports = __webpack_public_path__ + "static/media/EKEDC.62a496de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EKEDC.svg
// module id = 158
// module chunks = 25